import { useEffect } from 'react';
import { useRouter } from 'next/router'; // Next.js (Pages Router)

/**
 * 指定されたハッシュ値が含まれている場合にリダイレクトを行うフック
 * @param {string} targetHash - 監視対象のハッシュ値 (例: "program")
 * @param {string} redirectPath - リダイレクト先のパス (デフォルト: "/404")
 */
export const useCheckUrlHash = (targetHash, redirectPath = "/404") => {
  const router = useRouter();

  useEffect(() => {
    // ターゲットが指定されていない場合は何もしない（安全性確保）
    if (!targetHash) return;

    const checkHash = () => {
      // SSR対策
      if (typeof window === 'undefined') return false;

      const hash = window.location.hash.substring(1);

      // 引数で受け取った targetHash と比較
      if (hash === targetHash) {
        router.push(redirectPath);
        return true;
      }
      return false;
    };

    // 初回マウント時のチェック
    if (checkHash()) return;

    const handleHashChange = () => {
      checkHash();
    };

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [router, targetHash, redirectPath]); // 依存配列に引数を追加
};